module.exports = __webpack_public_path__ + "img/uk-infectious-diseases-male.04140cb5.png";